// extracted by mini-css-extract-plugin
export default {"coupon-list":"CouponList_coupon-list__+C7Ma"};